module.exports = __webpack_public_path__ + "static/media/disabledVerticalEventIcon.2f280ac5.svg";